module.exports = __webpack_public_path__ + "img/compact.92c92333.png";